import { GlobalService } from './../../global.service';
import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { ThemePalette, ProgressSpinnerMode } from '@angular/material';

@Component({
  selector: 'app-counter-report-per-day',
  templateUrl: './counter-report-per-day.component.html',
  styleUrls: ['./counter-report-per-day.component.scss']
})
export class CounterReportPerDayComponent implements OnInit {
  counter_list: any = [];
  selected_counter_id: any;
  selected_date: any = new Date().toISOString().split('T')[0];
  selected_report_option: any;
  counte_agent_order_details: any = null;
  grand_total_colspan: any = null;
  counter_customer_order_details: any;
  is_data_available = true;
  is_document_available: boolean = true;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  booth_code_list: string[];
  title: string;
  booth_or_customer_json: any = [];

  constructor(private httpService: HttpService, private global: GlobalService) {
    this.title = this.global._active_display_name;
    // this.title = 'Daily Counter Sale - Report';
    console.log(this.global._active_display_name);
    this.httpService.serveCounterList().subscribe((data) => {
      console.log(data);
      this.counter_list = data['final_list'];
      this.booth_or_customer_json = data['booth_or_customer_json'];
    }, (error) => {
      console.error(error);
    });
  }

  printCalled() {
    var divToPrint=document.getElementById("printTable");
    let newWin= window.open("");
    newWin.document.write(divToPrint.outerHTML);
    newWin.print();
    newWin.close();
  }

  getClicked() {
    let data_dict = {
      'selected_counter_id': this.selected_counter_id,
      'selected_date': this.selected_date,
      'selected_report_option': this.selected_report_option
    };
    console.log(data_dict);
    this.is_data_available = false;
    if (this.selected_report_option === 'booth') {
      this.httpService.serveCounterReportJsonForAgent(data_dict).subscribe((data) => {
        console.log(data);
        this.is_data_available = true;
        this.counte_agent_order_details = data;
        this.booth_code_list = data['booth_list'];
        this.grand_total_colspan = this.counte_agent_order_details['product_list'].length + 3;
        console.log(this.grand_total_colspan);
        // setTimeout(() => {
        //   document.getElementById('grand_total').setAttribute("colspan", this.grand_total_colspan);
        // }, 1000);
        console.log(this.counte_agent_order_details);
      }, (error) => {
        this.is_data_available = true;
        console.error(error);
      });
    } else {
      this.httpService.serveCounterReportJsonForCustomer(data_dict).subscribe((data) => {
        console.log(data);
        this.is_data_available = true;
        this.counter_customer_order_details = data;
        this.counter_customer_order_details['product_wise_liter'] = {};
        let total_packet = 0;
        let total_liter = 0;
        for (let product of data['product_list']) {
          this.counter_customer_order_details['product_wise_liter'][product['id']] = 0;
          this.counter_customer_order_details['product_wise_liter'][product['id']] = (this.counter_customer_order_details['product_total_count'][product['id']] * product['quantity']) / 1000;
          total_packet += this.counter_customer_order_details['product_total_count'][product['id']];
          total_liter += this.counter_customer_order_details['product_wise_liter'][product['id']]
        }
        this.counter_customer_order_details['total_packet'] = total_packet;
        this.counter_customer_order_details['total_liter'] = total_liter;
        this.grand_total_colspan = this.counter_customer_order_details['product_list'].length + 5;
        setTimeout(() => {
          document.getElementById('grand_total').setAttribute("colspan", this.grand_total_colspan);
        }, 1000);
      }, (error) => {
        this.is_data_available = true;
        console.error(error);
      });
    }
  }

  downloadReportCliked() {
    let data_dict = {
      'selected_counter_id': this.selected_counter_id,
      'selected_date': this.selected_date,
      'selected_report_option': this.selected_report_option
    };
    this.is_document_available = false;
    this.httpService.serveCounterReportForAgent(data_dict).subscribe((data) => {
      const linkSource = 'data:application/pdf;base64,' + data['pdf'];
      const downloadLink = document.createElement("a");
      const fileName = data['file_name'];
      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
      this.is_document_available = true;
    }, (error) => {
      this.is_document_available = true;
      console.error(error);
    });
  }

  checkDisable() {
    if (this.selected_counter_id == null || this.selected_date == null || this.selected_report_option == null) {
      return true;
    } else {
      return false;
    }
  }

  ngOnInit() {
  }

}
